import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios'
import { BACKEND_URL, FORBIDDEN_PATH } from '../constants/globalConstants'
import { isAuthenticated } from './auth'
import store from '../store'
import { authDataResetAction } from '../modules/AuthForm/AuthForm-actions'
import { toast } from 'react-toastify'
import history from './history'
import { getToken, LSClear } from './storage'
// import { useAuthModal, useLocation, useLogout } from './hooks'

export const instance: AxiosInstance = axios.create({
  withCredentials: false,
  baseURL: BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

instance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error: AxiosError) => {
    Promise.reject(error)
  }
)

instance.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response
  },
  (error) => {
    // const authOpen = useAuthModal()
    // const location = useLocation()
    // const logout = useLogout()
    if (error.response) {
      switch (error.response.status) {
        case 400:
          // not correct response
          break
        case 401:
          // Некорректные данные для входа
          if (isAuthenticated()) {
            store.dispatch(authDataResetAction())
            toast.info('Пожалуйста, войдите снова')
          }
          // history.push('/signin')
          LSClear()
          break
        // return
        case 403:
          // No token provided
          history.push(FORBIDDEN_PATH)
          break
        case 404:
          history.push('/404')
          break
        case 500:
          toast.error('Сервер вернул ошибку 500')
          break
        default:
          console.log('Other error')
          break
      }
    } else if (error.request) {
      console.log('Incorrect request')
    } else {
      console.log('something else in interceptor axios')
    }
    return Promise.reject(error.response?.data?.detail[0]?.msg)
  }
)
